import {gql} from '@apollo/client';

export const GET_SORTER_SORTING_LOG_LISTING = gql`
    query GetSorterSortingLogListing(
        $filters: SorterSortingLogFiltersInput
        $pageRequest: SorterSortingLogPageRequestInput
    ) {
        getSorterSortingLogListing(filters: $filters, pageRequest: $pageRequest) {
            content {
                id
                sorterId
                sorterCode
                sorterName
                sorterPlanId
                sorterPlanName
                trackingNumber
                sourceType
                bagId
                bagNumber
                expectSorterSortingChuteIds
                expectSorterSortingChuteCodes
                sorterSortingChuteId
                sorterSortingChuteCode
                uuid
                sortingTaskId
                requestJson
                responseJson
                exceptionJson
                remark
                operateAt
                createdAt
                createdBy
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface SorterSortingLogType {
    id: string;
    sorterId?: number;
    sorterCode?: string;
    sorterName?: string;
    sorterPlanId?: number;
    sorterPlanName?: string;
    trackingNumber?: string;
    sourceType: number;
    bagId?: number;
    bagNumber?: string;
    expectSorterSortingChuteIds?: string;
    expectSorterSortingChuteCodes?: string;
    sorterSortingChuteId?: number;
    sorterSortingChuteCode?: string;
    uuid?: string;
    /** 上机任务ID（中科 WCS 生成，同一次上机的扫描/落格/图片共用） */
    sortingTaskId?: string;
    requestJson?: string;
    responseJson?: string;
    exceptionJson?: string;
    remark?: string;
    operateAt?: number;
    createdAt?: number;
    createdBy?: string;
}

export interface SorterSortingLogListingResponseType {
    content: SorterSortingLogType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface SorterSortingLogListingResponse {
    getSorterSortingLogListing: SorterSortingLogListingResponseType;
}

export interface SorterSortingLogFiltersInput {
    warehouseId?: number;
    sorterId?: number;
    sorterPlanId?: number;
    sourceType?: number;
    trackingNumber?: string;
    bagNumber?: string;
    sorterSortingChuteCode?: string;
    uuid?: string;
    /** 上机任务ID，精确匹配 */
    sortingTaskId?: string;
    expectSorterSortingChuteCodes?: string;
    createdAtStart?: number;
    createdAtEnd?: number;
}
